import { useState, useEffect } from "react";

const images = Array.from(
  { length: 5 },
  (_, i) => `/educatie/profesional/poze/${i + 1}.jpg`
);

export default function InvProfesionalPage() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main className="max-w-7xl mx-auto px-4 py-8 bg-gray-50">
      {images.length > 0 && (
        <div className="w-full flex flex-col items-center">
          <div
            className="w-full max-w-4xl aspect-[16/6] bg-white border border-gray-200 overflow-hidden rounded-xl shadow-xl relative"
            style={{ minHeight: "500px" }}
          >
            {/* Image */}
            <img
              src={images[current]}
              alt={`carousel-${current}`}
              className="w-full h-full object-cover transition-all duration-700 mx-auto"
              style={{
                boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                borderRadius: "1rem",
              }}
            />
            {/* Navigation Orbs */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {images.map((_, index) => (
                <div
                  key={index}
                  className={`rounded-full transition-all duration-300 cursor-pointer ${
                    index === current ? "w-4 h-4" : "w-3 h-3"
                  }`}
                  style={{
                    backgroundColor:
                      index === current
                        ? "rgb(170,190,107)"
                        : "rgb(211,211,211)",
                    boxShadow:
                      index === current
                        ? "0 0 8px rgba(170,190,107,0.8)"
                        : "0 0 4px rgba(0,0,0,0.2)",
                  }}
                  onClick={() => setCurrent(index)}
                  aria-label={`Slide ${index + 1}`}
                ></div>
              ))}
            </div>
            {/* Navigation Buttons */}
            <button
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 rounded-full p-3 shadow-lg hover:bg-opacity-100 focus:outline-none"
              onClick={() =>
                setCurrent((current - 1 + images.length) % images.length)
              }
              aria-label="Previous"
            >
              &#8249;
            </button>
            <button
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 rounded-full p-3 shadow-lg hover:bg-opacity-100 focus:outline-none"
              onClick={() => setCurrent((current + 1) % images.length)}
              aria-label="Next"
            >
              &#8250;
            </button>
          </div>
        </div>
      )}
    </main>
  );
}
